import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

@Component({
  selector: 'app-property-upload-navigation',
  templateUrl: './property-upload-navigation.component.html',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, LoaderComponent],
})
export class PropertyUploadNavigationComponent {
  @Input() loading: boolean = false;
  @Input() HidePrevious: boolean = false;
  @Input() HideNext: boolean = false;
  @Input() NextDisabled: boolean = false;
  @Input() PreviousDisabled:boolean = false;
  
  @Output() PreviousButtonClicked: EventEmitter<void> = new EventEmitter();
  @Output() NextButtonClicked: EventEmitter<void> = new EventEmitter();

  constructor() {}

  NextButton() {
    this.NextButtonClicked.emit();
  }
  PreviousButton() {
    this.PreviousButtonClicked.emit();
  }
}

